/**************************************************
 * Nombre:       Formulario_Curso_Valores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Tarjetas_Valores from "../../Tarjeta/Tarjetas_Valores";
import Formulario_Valores from "./Formulario_Valores";

const Formulario_Curso_Valores = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Valor',
        Formulario: Formulario_Valores,
        dato: 'valores',
        Tarjeta: Tarjetas_Valores,
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Justificacion de valores: '} dato={'justificacion'} {...props}
                                  ejemplo={'Si es abogado quedará registrados cómo conciliadores ante el Ministerio de Justicia, si eres estudiante como capacitado para ejercer como conciliador cuándo cumplan los demás requisitos de la ley 2220 de 2022.'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Ingresar Valores</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Curso_Valores